import { Kullanici } from './kullanici';

export class TalepAciklama {
    aciklama: string;
    kullanici: Kullanici;
    talepId: number;

    constructor(obj?: any) {
        if (obj == null) {
            return;
        }
        Object.assign(this, obj);
    }
}
